import React from "react";
import { Tabs } from "../../../../CommonComponents";
import "./UsersGrid/UserManagementGrid.scss";

interface IProps {
  tabItems: any;
  handleLinkClick: (event: any) => void;
  selectedKey: string;
}
const UserManagement = ({ tabItems, handleLinkClick, selectedKey }: IProps) => {
  return (
    <div className="adminCardClass ">
      <h5 className="headingClass">User Management</h5>
      <div className="right-block">
        <div>
          <Tabs
            className={`custom-tab `}
            tabItems={tabItems}
            selectedKey={selectedKey}
            handleLinkClick={handleLinkClick}
           data-attribute="UserMangement_Default_Tabs" />
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
